import React from "react";

function AccessDeniedPage() {
  return <div>Your access is restricted</div>;
}

export default AccessDeniedPage;
